import { render, staticRenderFns } from "./faceRecord.vue?vue&type=template&id=6c6cd01c&scoped=true&"
import script from "./faceRecord.vue?vue&type=script&lang=js&"
export * from "./faceRecord.vue?vue&type=script&lang=js&"
import style0 from "./faceRecord.vue?vue&type=style&index=0&id=6c6cd01c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6cd01c",
  null
  
)

export default component.exports